import React from "react";

function PendingPaymentLink() {
  return (
    <svg
      width="32"
      height="32"
      fill="none"
      viewBox="0 0 32 32"
    >
      <rect width="32" height="32" fill="#FFFBE6" rx="8"></rect>
      <path
        stroke="#FAAD14"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.8"
        d="M17.517 22.325h-8.8a2.2 2.2 0 01-2.2-2.2v-8.25a2.2 2.2 0 012.2-2.2h13.2a2.2 2.2 0 012.2 2.2v3.85m-17.05-2.2h16.5m-2.75 6.184h4.666"
      ></path>
    </svg>
  );
}

export default PendingPaymentLink;